export class ConnectCustomerVaultAccountResponse {
    'vaultAccount';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vaultAccount",
            "baseName": "vaultAccount",
            "type": "CustomerVaultAccount",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectCustomerVaultAccountResponse.attributeTypeMap;
    }
    constructor() {
    }
}
